var _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAchatsEtServices = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.42 51.92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.06 10.95 18.7 .5 36.51 13.55 26.79 32.99 5.57 32.84 1.06 10.95",
    fill: "#66c",
    opacity: 0.2,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.92,43.11v-26.72H16.95v9.53h-.44c-2.14,0-3.89,1.74-3.89,3.89v2.76h-2.99l-1.81,18.83h44.93v-2.4h-6.83v-5.89h15ZM19.35,18.79h39.18v21.92h-31.01l-.72-8.14h-3.58v-2.76c0-2.13-1.73-3.87-3.86-3.89v-7.13ZM15.02,29.8c0-.82.67-1.49,1.49-1.49h2.81s.02,0,.03,0c.81.02,1.46.67,1.46,1.49v2.76h-5.79v-2.76ZM25.12,49h-14.65l1.35-14.04h12.78l.51,5.75.21,2.4.52,5.89h-.72ZM34.35,49v-5.73h9.17v5.73h-9.17ZM31.96,49h-3.71l-.52-5.89h4.23v5.89Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.59,
    y: 25.5,
    width: 9.13,
    height: 2.4,
    transform: "translate(-7.74 27.29) rotate(-33.02)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.7,
    y: 31.6,
    width: 9.13,
    height: 2.4,
    transform: "translate(-10.08 31.6) rotate(-33.02)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.24,
    y: 28.7,
    width: 15.27,
    height: 2.4,
    transform: "translate(-9.04 29.29) rotate(-33.02)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAchatsEtServices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/achats et services.292f0f3287136f27cccb6985f75152ed.svg";